export default "__VITE_ASSET__4423fd9e__"